import { render, staticRenderFns } from "./PubContact.vue?vue&type=template&id=c9d022a8&scoped=true&"
import script from "./PubContact.vue?vue&type=script&lang=js&"
export * from "./PubContact.vue?vue&type=script&lang=js&"
import style0 from "./PubContact.vue?vue&type=style&index=0&id=c9d022a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d022a8",
  null
  
)

export default component.exports